import "../../../Styles/tab.component.css";

import { Paper, Tabs } from "@mantine/core";
import { useEffect, useState } from "react";
import BreadcrumbLayout1 from "../../../_base/component/_layout/_breadcrumb";
import { repositoryPos } from "../../../_base/_const/_constVar";
import { MessageResponse } from "../../../model/MessageResponse";
import {
  TAG_API,
  TAG_OBJECT_TYPES,
  TagObjectType,
} from "../../../model/TblDmTag";
import TagCategoryList from "./TagCategoryList";
import TagList from "./TagList";

const TagConfig = () => {
  const [activeTab, setActiveTab] = useState<string | null>("tag");
  // Danh mục đang lọc ở tab Tag (khi mở từ tab Danh mục tag)
  const [categoryFilter, setCategoryFilter] = useState<string | null>(null);
  const [objectTypes, setObjectTypes] =
    useState<TagObjectType[]>(TAG_OBJECT_TYPES);

  const viewTagsOfCategory = (categoryId: string) => {
    setCategoryFilter(categoryId);
    setActiveTab("tag");
  };

  useEffect(() => {
    const fetchObjectTypes = async () => {
      const res = await repositoryPos.get<MessageResponse<TagObjectType[]>>(
        TAG_API.objectTypes,
        true
      );
      if (res?.success && res.data?.length) setObjectTypes(res.data);
    };
    fetchObjectTypes();
  }, []);

  return (
    <>
      <div
        style={{
          border: "1px solid #dee2e6",
          padding: "0px 10px",
        }}
      >
        <BreadcrumbLayout1></BreadcrumbLayout1>
      </div>
      <Paper shadow="md" radius="lg">
        <Tabs p={"xs"} value={activeTab} onChange={setActiveTab}>
          <Tabs.List>
            <Tabs.Tab value="tag">Tag</Tabs.Tab>
            <Tabs.Tab value="category">Danh mục tag</Tabs.Tab>
          </Tabs.List>

          <Tabs.Panel value="tag">
            {activeTab === "tag" ? (
              <TagList
                objectTypes={objectTypes}
                categoryFilter={categoryFilter}
                onCategoryFilterChange={setCategoryFilter}
              />
            ) : (
              <></>
            )}
          </Tabs.Panel>
          <Tabs.Panel value="category">
            {activeTab === "category" ? (
              <TagCategoryList
                objectTypes={objectTypes}
                onViewTags={viewTagsOfCategory}
              />
            ) : (
              <></>
            )}
          </Tabs.Panel>
        </Tabs>
      </Paper>
    </>
  );
};

export default TagConfig;
